import React from 'react';
import { Color } from 'modules/styles/colors';

export const stylesSH = {
  fill: Color.selectHealth
};

const styles = {
  fill: Color.white,
  stroke: Color.black,
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeMiterlimit: 10
} as const;

export default {
  svg: (
    <g>
      <path
        {...styles}
        d="M17.2,20.2H3c-0.5,0-1-0.4-1-1V5c0-0.5,0.4-1,1-1h14.2c0.5,0,1,0.4,1,1v14.2C18.1,19.8,17.7,20.2,17.2,20.2z"
      />
      <circle {...stylesSH} cx="10.6" cy="8.2" r="1.8" />
      <path
        {...stylesSH}
        d="M4.3,10.8c0.2-0.2,0.6-0.5,1.5,0.1c1,0.6,3.2,2.4,3.2,2.4s0.5,0.3,1.3,0.3c0.8,0,1.4-0.4,1.4-0.4
		S20.3,7.5,21,7c0.7-0.5,1.1-0.7,1.6-0.4s0.4,1-0.4,1.7c-0.5,0.4-9.7,8.5-9.7,8.5s-1.2,1.3-2.5,1.3c-0.2,0-0.9,0.1-1.4-0.5
		c-0.8-0.8-4.4-5.5-4.4-5.5C3.9,11.6,4,11,4.3,10.8z"
      />
    </g>
  ),
  viewBox: '0 0 24 24'
};
